import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/web'
import news from '@/components/news'
import developer from '@/developer'
// 手机发起端管理
import mobileApp from '@/components/mobileApp'

// 卡片管理 esCard
import esCard from '@/components/esCard/esCard'
import versionCard from '@/components/esCard/versionCard'

// 快应用管理 esApp
import esApp from '@/components/esApp/esApp'
import version from '@/components/esApp/version'

// sdk插件 esSdk
import esSdk from '@/components/esSdk/esSdk'
import versionSdk from '@/components/esSdk/versionSdk'

// 用户权限管理
import esRole from '@/components/authority/esRole'
import subUser from '@/components/authority/subUser'
import esUser from '@/components/authority/esUser'

// 测试sdk插件 esSdkTest
import esSdkTest from '@/components/esSdkTest/esSdkTest'
import versionSdkTest from '@/components/esSdkTest/versionSdkTest'

// 测试快应用 esAppTest
import esApkTest from '@/components/esApkTest/esApkTest'
import versionApkTest from '@/components/esApkTest/versionApkTest'

// 测试Apk插件 esApkTest
import esAppTest from '@/components/esAppTest/esAppTest'
import versionTest from '@/components/esAppTest/versionTest'

// apk插件 esApk
import esApk from '@/components/esApk/esApk'
import versionApk from '@/components/esApk/versionApk'

// 测试用户管理
import testUsers from '@/components/testUsers'

// 渠道管理
import channelManage from '@/components/channelManage'

// 审核管理 check
import checkApp from '@/components/check/checkApp'
import checkSdk from '@/components/check/checkSdk'
import checkApk from '@/components/check/checkApk'
import checkVersion from '@/components/check/checkVersion'
import checkCertification from '@/components/check/checkCertification'
import checkIndividual from '@/components/check/checkIndividual'
import checkPay from '@/components/check/checkPay'

import testMac from '@/components/testMac'
import testMacHM from '@/components/testMacHM'
import testMacSdk from '@/components/testMacSdk'
import report from '@/components/report'
import certification from '@/components/certification'
import users from '@/components/users'
import shelfShop from '@/components/shelfShop'
import dataCenter from '@/components/dataCenter'
import payDetails from '@/components/payDetails'
import bills from '@/components/bills'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '平台首页',
        name: 'index'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/developer',
      name: 'developer',
      component: developer,
      children: [
        {
          path: 'esApp',
          name: 'esApp',
          component: esApp,
          meta: {
            title: '小程序管理',
            name: 'esApp'
          }
        },
        {
          path: 'version',
          name: 'version',
          component: version,
          meta: {
            title: '版本管理',
            name: 'version',
            parent: [
              {
                title: '小程序管理',
                name: 'esApp'
              }
            ]
          }
        },
        {
          path: 'esSdk',
          name: 'esSdk',
          component: esSdk,
          meta: {
            title: 'SDK插件管理',
            name: 'esSdk'
          }
        },
        {
          path: 'esRole',
          name: 'esRole',
          component: esRole,
          meta: {
            title: '角色管理',
            name: 'esRole'
          }
        },
        {
          path: 'esUser',
          name: 'esUser',
          component: esUser,
          meta: {
            title: '用户管理',
            name: 'esUser'
          }
        },
        {
          path: 'subUser',
          name: 'subUser',
          component: subUser,
          meta: {
            title: '子用户管理',
            name: 'subUser',
            parent: [
              {
                title: '用户管理',
                name: 'esUser'
              }
            ]
          }
        },
        {
          path: 'versionSdk',
          name: 'versionSdk',
          component: versionSdk,
          meta: {
            title: 'sdk版本管理',
            name: 'versionSdk',
            parent: [
              {
                title: 'SDK插件管理',
                name: 'esSdk'
              }
            ]
          }
        },
        {
          path: 'esApk',
          name: 'esApk',
          component: esApk,
          meta: {
            title: 'APK插件管理',
            name: 'esApk'
          }
        },
        {
          path: 'versionApk',
          name: 'versionApk',
          component: versionApk,
          meta: {
            title: 'apk版本管理',
            name: 'versionApk',
            parent: [
              {
                title: 'APK插件管理',
                name: 'esApk'
              }
            ]
          }
        },
        {
          path: 'versionCard',
          name: 'versionCard',
          component: versionCard,
          meta: {
            title: '版本管理',
            name: 'versionCard',
            parent: [
              {
                title: '卡片管理',
                name: 'esCard'
              }
            ]
          }
        },
        {
          path: 'esCard',
          name: 'esCard',
          component: esCard,
          meta: {
            title: '卡片管理',
            name: 'esCard'
          }
        },
        {
          path: 'mobileApp',
          name: 'mobileApp',
          component: mobileApp,
          meta: {
            title: '手机发起端管理',
            name: 'mobileApp'
          }
        },
        {
          path: 'report',
          name: 'report',
          component: report,
          meta: {
            title: '数据统计',
            name: 'report'
          }
        },
        {
          path: 'certification',
          name: 'certification',
          component: certification,
          meta: {
            title: '资质认证',
            name: 'certification'
          }
        },
        {
          path: 'checkApp',
          name: 'checkApp',
          component: checkApp,
          meta: {
            title: '小程序审核',
            name: 'checkApp'
          }
        },
        {
          path: 'checkSdk',
          name: 'checkSdk',
          component: checkSdk,
          meta: {
            title: '插件审核',
            name: 'checkSdk'
          }
        },
        {
          path: 'checkApk',
          name: 'checkApk',
          component: checkApk,
          meta: {
            title: '插件版本审核',
            name: 'checkApk'
          }
        },
        {
          path: 'checkVersion',
          name: 'checkVersion',
          component: checkVersion,
          meta: {
            title: '小程序版本审核',
            name: 'checkVersion'
          }
        },
        {
          path: 'checkCertification',
          name: 'checkCertification',
          component: checkCertification,
          meta: {
            title: '企业资质审核',
            name: 'checkCertification'
          }
        },
        {
          path: 'checkIndividual',
          name: 'checkIndividual',
          component: checkIndividual,
          meta: {
            title: '开发者资质审核',
            name: 'checkIndividual'
          }
        },
        {
          path: 'checkPay',
          name: 'checkPay',
          component: checkPay,
          meta: {
            title: '支付审核',
            name: 'checkPay'
          }
        },
        {
          path: 'esAppTest',
          name: 'esAppTest',
          component: esAppTest,
          meta: {
            title: '测试小程序',
            name: 'esAppTest'
          }
        },
        {
          path: 'versionTest',
          name: 'versionTest',
          component: versionTest,
          meta: {
            title: '测试小程序版本管理',
            name: 'versionTest',
            parent: [
              {
                title: '测试小程序',
                name: 'esAppTest'
              }
            ]
          }
        },
        {
          path: 'esSdkTest',
          name: 'esSdkTest',
          component: esSdkTest,
          meta: {
            title: '测试sdk管理',
            name: 'esSdkTest'
          }
        },
        {
          path: 'versionSdkTest',
          name: 'versionSdkTest',
          component: versionSdkTest,
          meta: {
            title: '测试sdk版本管理',
            name: 'versionSdkTest',
            parent: [
              {
                title: '测试sdk管理',
                name: 'esSdkTest'
              }
            ]
          }
        },
        {
          path: 'esApkTest',
          name: 'esApkTest',
          component: esApkTest,
          meta: {
            title: '测试apk管理',
            name: 'esApkTest'
          }
        },
        {
          path: 'versionApkTest',
          name: 'versionApkTest',
          component: versionApkTest,
          meta: {
            title: '测试apk版本管理',
            name: 'versionApkTest',
            parent: [
              {
                title: '测试apk管理',
                name: 'esApkTest'
              }
            ]
          }
        },
        {
          path: 'users',
          name: 'users',
          component: users,
          meta: {
            title: '用户权限管理',
            name: 'users'
          }
        },
        {
          path: 'testUsers',
          name: 'testUsers',
          component: testUsers,
          meta: {
            title: '测试用户权限管理',
            name: 'testUsers'
          }
        },
        {
          path: 'channelManage',
          name: 'channelManage',
          component: channelManage,
          meta: {
            title: '渠道管理',
            name: 'channelManage'
          }
        },
        {
          path: 'testMac',
          name: 'testMac',
          component: testMac,
          meta: {
            title: '小程序定投',
            name: 'testMac'
          }
        },
        {
          path: 'testMacHM',
          name: 'testMacHM',
          component: testMacHM,
          meta: {
            title: '鸿蒙小程序定投',
            name: 'testMacHM'
          }
        },
        {
          path: 'testMacSdk',
          name: 'testMacSdk',
          component: testMacSdk,
          meta: {
            title: '插件定投',
            name: 'testMacSdk'
          }
        },
        {
          path: 'dataCenter',
          name: 'dataCenter',
          component: dataCenter,
          meta: {
            title: '数据中心',
            name: 'dataCenter'
          }
        },
        {
          path: 'payDetails',
          name: 'payDetails',
          component: payDetails,
          meta: {
            title: '订单明细',
            name: 'payDetails'
          }
        },
        {
          path: 'bills',
          name: 'bills',
          component: bills,
          meta: {
            title: '结算中心',
            name: 'bills'
          }
        },
        {
          path: 'shelfShop',
          name: 'shelfShop',
          component: shelfShop,
          meta: {
            title: '上架商店',
            name: 'shelfShop'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js